import type {ResultadoDeEliminarBigBags, ResultadoDeEliminarExportaciones} from '@cnc/contracts';
import {tr} from '../i18n/idioma';
import {numero} from '../utilidades/formato';
import type {RevisionDeEliminacion} from './boton-de-eliminar';

// Textos del aviso de eliminar y del resultado, a partir de lo que dice la API.
const lista = (ejemplos: string[], total: number) =>
  ejemplos.join(', ') +
  (total > ejemplos.length
    ? tr(` y ${numero(total - ejemplos.length)} más`, ` and ${numero(total - ejemplos.length)} more`)
    : '');

export function revisionDeExportaciones(r: ResultadoDeEliminarExportaciones): RevisionDeEliminacion {
  const lineas: string[] = [];
  if (r.cantidad)
    lineas.push(
      tr(
        `Se eliminarán ${numero(r.cantidad)} exportaciones: ${lista(r.ejemplos, r.cantidad)}, con su seguimiento, contenedores, alertas, facturas y documentos.`,
        `${numero(r.cantidad)} exports will be deleted: ${lista(r.ejemplos, r.cantidad)}, with their tracking, containers, alerts, invoices and documents.`,
      ),
    );
  else lineas.push(tr('No hay exportaciones que se puedan eliminar.', 'There are no exports that can be deleted.'));
  if (r.bigBagsLiberados)
    lineas.push(
      tr(
        `${numero(r.bigBagsLiberados)} Big Bags asignados vuelven a quedar disponibles.`,
        `${numero(r.bigBagsLiberados)} assigned Big Bags become available again.`,
      ),
    );
  if (r.bloqueadas.length)
    lineas.push(
      tr(
        `No se eliminan ${numero(r.bloqueadas.length)} porque tienen Big Bags ya exportados: ${lista(
          r.bloqueadas.slice(0, 10).map(b => b.codigo),
          r.bloqueadas.length,
        )}.`,
        `${numero(r.bloqueadas.length)} are not deleted because they have Big Bags already exported: ${lista(
          r.bloqueadas.slice(0, 10).map(b => b.codigo),
          r.bloqueadas.length,
        )}.`,
      ),
    );
  return {cantidad: r.cantidad, lineas};
}

export const mensajeDeExportaciones = (r: ResultadoDeEliminarExportaciones) =>
  tr(`Listo: ${numero(r.eliminadas)} exportaciones eliminadas.`, `Done: ${numero(r.eliminadas)} exports deleted.`) +
  (r.bloqueadas.length
    ? tr(
        ` ${numero(r.bloqueadas.length)} no se eliminaron porque tienen Big Bags exportados.`,
        ` ${numero(r.bloqueadas.length)} were not deleted because they have exported Big Bags.`,
      )
    : '');

export function revisionDeBigBags(r: ResultadoDeEliminarBigBags): RevisionDeEliminacion {
  const lineas: string[] = [];
  if (r.cantidad)
    lineas.push(
      tr(
        `Se eliminarán ${numero(r.cantidad)} Big Bags: ${lista(r.ejemplos, r.cantidad)}, con su historial.`,
        `${numero(r.cantidad)} Big Bags will be deleted: ${lista(r.ejemplos, r.cantidad)}, with their history.`,
      ),
    );
  else lineas.push(tr('No hay Big Bags para eliminar.', 'There are no Big Bags to delete.'));
  if (r.asignados)
    lineas.push(
      tr(
        `${numero(r.asignados)} están asignados a una exportación y saldrán de ella.`,
        `${numero(r.asignados)} are assigned to an export and will be removed from it.`,
      ),
    );
  if (r.exportados)
    lineas.push(
      tr(
        `Atención: ${numero(r.exportados)} ya fueron exportados; sus exportaciones y documentos quedarán sin ellos.`,
        `Warning: ${numero(r.exportados)} were already exported; their exports and documents will no longer include them.`,
      ),
    );
  return {cantidad: r.cantidad, lineas};
}

export const mensajeDeBigBags = (r: ResultadoDeEliminarBigBags) =>
  tr(`Listo: ${numero(r.eliminados)} Big Bags eliminados.`, `Done: ${numero(r.eliminados)} Big Bags deleted.`);
